/* Display-only prices. Shopify automatic discounts remain the checkout authority. */
(function () {
  'use strict';
  var config = window.HewnEarthSaleConfig || {};
  var expiresAt = Date.parse(config.endsAt || '');
  var enabled = config.enabled === true && (!Number.isFinite(expiresAt) || Date.now() < expiresAt);
  var rate = Math.min(100, Math.max(0, Number.isFinite(Number(config.percent)) ? Number(config.percent) : 20));
  var multiRate = Math.min(100, Math.max(0, Number.isFinite(Number(config.multiPercent)) ? Number(config.multiPercent) : 25));
  var nativeCurrencies = ['USD', 'AUD', 'CAD', 'GBP', 'NZD'];
  function currencyCode(currency) {
    return /^[A-Z]{3}$/.test(currency || '') ? currency : config.currency || 'USD';
  }
  function cents(value) {
    var amount = Number(value);
    return Number.isFinite(amount) ? Math.max(0, Math.round(amount)) : 0;
  }
  function price(value, currency, percentage) {
    var amount = cents(value);
    if (!enabled) return amount;
    // Shopify floors the product discount allocation in these markets.
    var percent = percentage === undefined ? rate : Math.min(100, Math.max(0, Number(percentage)));
    var discounted = amount * (100 - percent) / 100;
    return nativeCurrencies.includes(currencyCode(currency)) ? Math.ceil(discounted) : Math.round(discounted);
  }
  function escape(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character];
    });
  }
  function money(value, currency) {
    var code = currencyCode(currency);
    var digits = nativeCurrencies.includes(code) && cents(value) % 100 === 0 ? 0 : undefined;
    try {
      return new Intl.NumberFormat(config.locale || 'en', {style:'currency',currency:code,minimumFractionDigits:digits}).format(cents(value) / 100);
    } catch (error) {
      return new Intl.NumberFormat('en', {style:'currency',currency:'USD'}).format(cents(value) / 100);
    }
  }
  function priceHTML(value, currency) {
    var current = '<span class="he-sale-price__current">' + escape(money(price(value, currency), currency)) + '</span>';
    if (!enabled) return escape(money(value, currency));
    return '<span class="he-sale-price"><span class="he-sale-sr-only">Regular price </span><s class="he-sale-price__original">' + escape(money(value,currency)) + '</s><span class="he-sale-sr-only">Sale price </span>' + current + '</span>';
  }
  window.HewnEarthSale = Object.freeze({enabled:enabled,rate:enabled?rate:0,multiRate:multiRate,multiText:config.multiText || '',price:price,money:money,priceHTML:priceHTML,badgeHTML:function(){return enabled?'<span class="he-sale-badge">' + rate + '% OFF</span>':'';}});
  // Reload once at the boundary so Liquid-only bundle branches and all existing
  // price consumers receive the post-campaign HTML together, including restored tabs.
  if (enabled && Number.isFinite(expiresAt) && window.addEventListener) {
    var expiryTimer;
    var refreshing = false;
    function refreshAtExpiry() {
      window.clearTimeout(expiryTimer);
      if (Date.now() >= expiresAt) {
        if (!refreshing) { refreshing = true; window.location.reload(); }
        return;
      }
      expiryTimer = window.setTimeout(refreshAtExpiry, Math.min(expiresAt - Date.now(), 2147483647));
    }
    window.addEventListener('pageshow', refreshAtExpiry);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshAtExpiry(); });
    refreshAtExpiry();
  }
}());
